<template>
  <div>
    <div v-if="!isPrint">
      <el-button type="primary" style="margin-bottom:5px" @click="printPage">打印</el-button>
    </div>
    <div id="printContent">
      <table class="table">
        <tr>
          <td>
            收货单位:
            <span style="margin-left:30px">大足永晟事业发展有限公司标准厂房三期</span>
          </td>
          <td rowspan="2" style="border-bottom:none;width: 300px;">
            ||||二||||维|||码||||||
          </td>
        </tr>
        <tr>
          <td style="border-bottom:none">
            <span>客户合同号: 123456789</span>
            <span style="margin-left:200px">设备号/工号：123456789</span>
          </td>
        </tr>
      </table>
      <table class="table">
        <tr>
          <td>合同号:</td>
          <td>CF/D210805-1</td>
          <td>箱号:</td>
          <td>123456789</td>
          <td rowspan="2" style="width: 20px;border-bottom:none">梯号：</td>
          <td rowspan="2" style="border-bottom:none">123456</td>
        </tr>
        <tr>
          <td style="border-bottom:none">外形尺寸:</td>
          <td style="border-bottom:none">1850*700*610</td>
          <td style="border-bottom:none">毛重:</td>
          <td style="border-bottom:none">123456</td>
        </tr>
      </table>
      <table class="table">
        <tr>
          <td>名称</td>
          <td>型号(图形)</td>
          <td>规格</td>
          <td>技术参数</td>
          <td>数量</td>
        </tr>
        <tr>
          <td style="width: 90px;">控制柜</td>
          <td>1</td>
          <td>1</td>
          <td>1</td>
          <td>1套</td>
        </tr>
        <tr style="width: 90px;">
          <td>电缆线</td>
          <td>1</td>
          <td>1</td>
          <td>1</td>
          <td>1台</td>
        </tr>
        <tr style="width: 90px;">
          <td>电梯配件</td>
          <td>1</td>
          <td>1</td>
          <td>1</td>
          <td>1台</td>
        </tr>
      </table>
      <div style="width:900px;height:120px;display:inline-block;margin-top:5px">
        <span style="float:left;margin-left:20px">
          <img style="width:200px" src="../../../public/img/CQFSIcon.png">
        </span>
        <span style="float:left">
          <div style="width:650px;padding:8px">
            <span style="font-size:25px;font-weight:600">重庆富士电梯有限责任公司</span>
            <span style="margin-left:70px;font-weight:600;">电梯制造许可证：TS2310359-2018</span>
          </div>
          <div style="width:650px;">
            <span style="font-weight:600;margin-left:20px">CHONGQING FUJI ELEVATOR CO.,LTD </span>
            <span style="margin-left:100px;font-weight:600">Manufacture License No.</span>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isPrint:false,
      };
    },
    methods:{
      printPage() {
        this.isPrint = true;
        this.$nextTick(()=>{
          document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
          window.print();
          window.location.reload();
          this.isPrint = false;
          return false;
        });
       
      },
    },
  };
</script>

<style lang="scss" scoped>
.table{
  margin: 0;
  width: 900px;
  border-collapse: collapse;
}
.table td{
  border: 1px solid #333;
  margin: 0;
  padding: 10px;
}
</style>